module.exports = "<svg id=menu-pause data-name=\"Слой 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 24 26\"> <rect class=cls-8 width=8 height=26 rx=1 ry=1 /> <rect class=cls-8 x=16 width=8 height=26 rx=1 ry=1 /> </svg>";


//////////////////
// WEBPACK FOOTER
// ./public/web/images/pausa_menu_mob.svg
// module id = 5kBG
// module chunks = 3 4